export type BoardGridSelectionClickEvent = { column?: { getColId?: () => string } | null; event?: Event | null };

const BOARD_SELECTION_CLICK = '.ag-selection-checkbox, .ag-checkbox-input-wrapper, .ag-header-select-all, .list-row-checkbox, [col-id="ag-Grid-SelectionColumn"]';

/** Checkbox / select-all chrome — never a row open, navigate, or panel retarget. */
export function isBoardGridSelectionClick(event: BoardGridSelectionClickEvent | null | undefined): boolean {

  const colId = event?.column?.getColId?.();
  if (colId === 'ag-Grid-SelectionColumn') return true;
  const target = event?.event?.target instanceof Element ? event.event.target : null;
  return !!target?.closest(BOARD_SELECTION_CLICK);
}

/** True when the event is selection chrome; stops it so a parent dialog/row handler cannot see it. */
export function consumeBoardGridSelectionClick(event: BoardGridSelectionClickEvent | null | undefined): boolean {

  if (!isBoardGridSelectionClick(event)) return false;
  event?.event?.stopPropagation();
  return true;
}
